import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddStaffInfoComponent } from './add-staff-info.component';
import { SharedModule } from '../../../../../shared/shared.module';
import { MaterialModule } from '../../../../../shared/material.module';



@NgModule({
  declarations: [
    AddStaffInfoComponent
  ],
  exports: [
    AddStaffInfoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule
  ]
})
export class AddStaffInfoModule { }
